import { PROMO_CODE_MODEL_KEY_POINTER } from 'models/daos/promo-code/constants'

const PROMO_CODES_DOMAIN = 'promoCodes'
const PROMO_CODES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  new: null
}

const PROMO_CODES_DOMAIN_MAP_KEY = PROMO_CODE_MODEL_KEY_POINTER
const PROMO_CODES_PATH = {
  DATA: `${PROMO_CODES_DOMAIN}.data`,
  NEW: `${PROMO_CODES_DOMAIN}.new`
}

const PROMO_CODES_ACTION = {
  UPDATE_PROMO_CODE: 'UPDATE_PROMO_CODE'
}

export {
  PROMO_CODES_DOMAIN,
  PROMO_CODES_DOMAIN_MAP_KEY,
  PROMO_CODES_PATH,
  PROMO_CODES_STATE,
  PROMO_CODES_ACTION
}
